export default __webpack_public_path__ + "static/media/komin-1_2.268512e9.jpg";